import { render } from "./ContactUs.vue?vue&type=template&id=74bfb5de&scoped=true&ts=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=74bfb5de&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bfb5de"]])

export default __exports__